import { render, staticRenderFns } from "./CallMobileGifts.vue?vue&type=template&id=3201a2e9"
import script from "./CallMobileGifts.vue?vue&type=script&lang=js"
export * from "./CallMobileGifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports